export default function anonymous(props
) {
var out='<div data-playable-hook="time-control" class="'+(props.styles.timeWrapper)+' '+(props.themeStyles.timeText)+'"> <span data-playable-hook="current-time-indicator" class="'+(props.styles.time)+'"> </span> <span data-playable-hook="duration-time-indicator" class="'+(props.styles.time)+' '+(props.styles.duration)+'"> </span></div>';return out;
}